import { stationProcessingSessionIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";
import { StationProcessingSession } from "./station-processing-session";

export const closeStationProcessingSession = {
  name: "closeStationProcessingSession" as const,
  input: z.object({ sessionId: stationProcessingSessionIdFormat.schema }),
  output: z.object({ session: StationProcessingSession }),
};
